import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { PurposeDto } from '@cradua/data';
import { Observable } from 'rxjs/internal/Observable';
import { routeAnimations, ROUTE_ANIMATIONS_ELEMENTS } from 'libs/core/src/lib/animations';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-purpose-container',
  templateUrl: './purpose-container.component.html',
  styleUrls: ['./purpose-container.component.scss']
})
export class PurposeContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  purposes$: Observable<PurposeDto[]>;
  loading: boolean;
  isLoading$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoading$ = this.gatwayFacade.isLoadingGateway("Purpose");
    this.purposes$ = this.gatwayFacade.loadGateway("Purpose");
    this.purposes$.subscribe(data => {
      console.log("data: cont.",data);

    })
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeletePurpose(deletedValue: any) {
    this.gatwayFacade.remove("Purpose", deletedValue);
    // this.store.dispatch(PurposeStoreActions.removePurpose({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }


// this method control both the create and update

  onSubmitPurpose(formValue: any) {
    console.log("form value: ", formValue);
    formValue.Purposes = formValue.Purposes.reverse();
    event.preventDefault();
    const pullData = formValue.Purposes;
    //const newPullData = formValue.Purposees;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllPurpose = [];


// loop through the form data to check for update and create

  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllPurpose.push(pullData[i]);
    }
  }

// check if the addAllPurpose array is not empty, then dispatch the data to the store
   if(addAllPurpose.length !== 0) {
    this.gatwayFacade.add('Purpose', addAllPurpose);
    // this.store.dispatch(PurposeStoreActions.addPurpose({newPurpose: addAllPurpose}));

   }

// dispatch update data to the store
this.gatwayFacade.update('Purpose', allUpdates, ['id']);
    // this.store.dispatch(PurposeStoreActions.updatePurpose({updatePurpose: allUpdates}));
    this.notificationService.success('Saved Successfully');

  }

}
